import { render, staticRenderFns } from "./AttendanceChart.vue?vue&type=template&id=7c066137&scoped=true"
import script from "./AttendanceChart.vue?vue&type=script&lang=js"
export * from "./AttendanceChart.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChart.vue?vue&type=style&index=0&id=7c066137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c066137",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
